import React, { useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import HolidaysModal from "../../core/modals/holidaysModal";
import useApi from "../../core/customhook/useApi";
import Loader from "../../core/common/selfLoder";

interface Holiday {
  holiday: string;
  holiday_date: string;
  holiday_category: string;
  location: string;
}

interface HolidaysMainResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: Holiday[];
}
const Holidays: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>("");

  const tabs = [
    { key: "", label: "All Location Holidays" },
    { key: "MH", label: "Your Mandatory Holidays" },
    { key: "RH", label: "Your Restricted Holidays" },
  ];

  const safeSort = (a: Holiday, b: Holiday, key: keyof Holiday) => {
    if (!a[key]) return -1;
    if (!b[key]) return 1;
    return a[key]!.toString().localeCompare(b[key]!.toString());
  };

  const getOrdinal = (n: number) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };
  
  const mandatoryColumns = [
    {
      title: "SNo.",
      dataIndex: "key",
    },
    {
      title: "Occasion/Festival",
      dataIndex: "holiday",
      sorter: (a: Holiday, b: Holiday) => safeSort(a, b, "holiday"),
    },
    {
      title: "Date",
      dataIndex: "holiday_date",
      render: (date: string) => {
        const d = new Date(date);
        const day = getOrdinal(d.getDate()); // e.g. 1st
        const month = d.toLocaleString("en-IN", { month: "long" }); // January
        const year = d.getFullYear(); // 2025
        return `${day} ${month} ${year}`;
      },
      sorter: (a: Holiday, b: Holiday) =>
        new Date(a.holiday_date).getTime() - new Date(b.holiday_date).getTime(),
    },

    {
      title: "Day",
      dataIndex: "holiday_date",
      render: (date: string) =>
        new Date(date).toLocaleDateString("en-US", { weekday: "long" }),
      sorter: (a: Holiday, b: Holiday) =>
        new Date(a.holiday_date).getTime() - new Date(b.holiday_date).getTime(),
    },
    {
      title: "Location",
      dataIndex: "location",
      sorter: (a: Holiday, b: Holiday) => safeSort(a, b, "location"),
    },
  ];

  const restrictedColumns = [...mandatoryColumns];

  // const allLocationsColumns = [
  //   ...mandatoryColumns,
  //   {
  //     title: "Category",
  //     dataIndex: "holiday_category",
  //     sorter: (a: Holiday, b: Holiday) => safeSort(a, b, "holiday_category"),
  //   },
  // ];

const allLocationsColumns = [
  ...mandatoryColumns,
  {
    title: "Category",
    dataIndex: "holiday_category",
    sorter: (a: Holiday, b: Holiday) => safeSort(a, b, "holiday_category"),
    render: (value: string) => {
      if (value === "MH") return "Mandatory Holidays";
      if (value === "RH") return "Restricted Holidays";
      return value || "-";
    },
  },
];


  const getTableColumns = () => {
    switch (activeTab) {
      case "MH":
        return mandatoryColumns;
      case "RH":
        return restrictedColumns;
      case "":
        return allLocationsColumns;
      default:
        return [];
    }
  };


  const {
    data: holidayResponse,
    loading: holidayLoading,
    error: holidayError,
  } = useApi<HolidaysMainResponse>("/api/holiday-list", {
    method: "POST",
    autoCall: true,
    payload: {
      category: activeTab,
    },
    dependencies: [activeTab],
  });
  const tableData = (holidayResponse?.data || []).map((item, index) => ({
    ...item,
    location: item.location === null ? "All" : item.location,
    key: index + 1,
  }));
  console.log(tableData);

  return (
    <>
      {/* {holidayLoading && <Loader />} */}
      <Loader loading={holidayLoading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Holiday Calendar</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Company Overview</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Holiday Calendar
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
              <h5 className="mb-0">Holidays List </h5>
            </div>

            <div className="card-body">
              {/* Responsive tab buttons */}
              <div className="d-flex flex-nowrap gap-2 mb-3 overflow-auto text-nowrap py-2">
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    className="btn px-2 px-sm-4"
                    style={{
                      backgroundColor:
                        activeTab === tab.key ? "#2e3294" : "transparent",
                      color: activeTab === tab.key ? "#ffffff" : "#2e3294",
                      border: "1px solid #2e3294",
                      borderRadius: "15px",
                      fontWeight: "500",
                    }}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* Table container */}
              <div className="card table-responsive">
                <Table
                  dataSource={tableData}
                  columns={getTableColumns()}
                  Selection={false}
                  showSearchInput={true}
                />
              </div>
            </div>
          </div>
        </div>
        <HolidaysModal />

        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div >
    </>
  );
};

export default Holidays;
